export const caseStudies = [
  {
    id: 1,
    title: "Sydney Trades Business",
    industry: "Electrical Services",
    problem: "Missed enquiries during work hours and slow quote turnaround",
    solution: "Website enquiry automation, CRM pipeline tracking, and automated follow-up sequences",
    outcome: "Faster response process and clearer pipeline visibility across all leads",
    serviceLinks: [
      { name: "Premium Websites", slug: "premium-websites" },
      { name: "CRM Automation", slug: "crm-automation" },
      { name: "AI Chatbots", slug: "ai-chatbots" }
    ]
  },
  {
    id: 2,
    title: "Service Business Workflow",
    industry: "Allied Health Services",
    problem: "Manual spreadsheet tracking and inconsistent client follow-up",
    solution: "Custom dashboard and workflow automation to replace manual processes",
    outcome: "Better visibility into client interactions and fewer manual admin steps",
    serviceLinks: [
      { name: "Dashboards and Reporting", slug: "dashboards-reporting" },
      { name: "Process Automations", slug: "process-automations" },
      { name: "CRM Automation", slug: "crm-automation" }
    ]
  },
  {
    id: 3,
    title: "Professional Services Document Process",
    industry: "Legal Services",
    problem: "Repetitive proposal and document preparation consuming hours weekly",
    solution: "Reusable templates and automated document generation system",
    outcome: "Faster turnaround times and more consistent client communication",
    serviceLinks: [
      { name: "Process Automations", slug: "process-automations" },
      { name: "Premium Websites", slug: "premium-websites" }
    ]
  },
  {
    id: 4,
    title: "Construction Business Reporting",
    industry: "Construction Services",
    problem: "Scattered job data across spreadsheets and poor visibility into operations",
    solution: "Centralised workflow system, reporting dashboard, and lead capture integration",
    outcome: "Cleaner operations, better management visibility, and improved decision-making",
    serviceLinks: [
      { name: "Dashboards and Reporting", slug: "dashboards-reporting" },
      { name: "CRM Automation", slug: "crm-automation" },
      { name: "Process Automations", slug: "process-automations" }
    ]
  }
];